var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pa-3",
      staticStyle: { position: "relative", height: "calc(100vh - 100px)" }
    },
    [
      _vm.Loading
        ? _c(
            "v-layout",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                "z-index": "1000",
                background: "rgba(255, 255, 255, .95)"
              },
              attrs: { "align-center": "", "justify-center": "" }
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _c("div", { staticClass: "lds-roller" }, [
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Patientez SVP ...")])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c("h3", { staticClass: "mb-2 ml-4" }, [_vm._v("Filtrer par...")]),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "ml-4": "" } },
            [
              _vm.coApartments.length
                ? _c(
                    "v-flex",
                    { attrs: { xs2: "", "mr-3": "" } },
                    [
                      _c(
                        "base-condition-selector",
                        {
                          attrs: {
                            items: _vm.coApartments,
                            "on-fetch": _vm.handleApartmentRemoteFetch,
                            label: _vm.$t(_vm.lblSetting.lblApartment),
                            onChange: _vm.onChangeApartment,
                            "set-loader-state": _vm.setLoaderApartment
                          },
                          model: {
                            value: _vm.Apartment,
                            callback: function($$v) {
                              _vm.Apartment = $$v
                            },
                            expression: "Apartment"
                          }
                        },
                        [
                          _c(
                            "template",
                            { slot: "loader" },
                            [_c("filters-loader")],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs2: "", "mr-3": "" } },
                [
                  _c(
                    "base-search-selector",
                    {
                      attrs: {
                        items: _vm.coCharPbs1,
                        label: _vm.$t(_vm.lblSetting.equipmentHeaders.charPb1),
                        multiple: false
                      },
                      model: {
                        value: _vm.CharPb1,
                        callback: function($$v) {
                          _vm.CharPb1 = $$v
                        },
                        expression: "CharPb1"
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "loader" },
                        [_c("filters-loader")],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.CharPb1
                ? _c(
                    "v-flex",
                    { attrs: { xs2: "", "mr-3": "" } },
                    [
                      _c(
                        "base-search-selector",
                        {
                          attrs: {
                            items: _vm.coCharPbs2,
                            label: _vm.$t(
                              _vm.lblSetting.equipmentHeaders.charPb2
                            ),
                            multiple: true
                          },
                          model: {
                            value: _vm.CharPb2,
                            callback: function($$v) {
                              _vm.CharPb2 = $$v
                            },
                            expression: "CharPb2"
                          }
                        },
                        [
                          _c(
                            "template",
                            { slot: "loader" },
                            [_c("filters-loader")],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { shrink: "", "mr-3": "" } },
                [
                  _c(
                    "v-layout",
                    {
                      attrs: { "align-center": "", row: "", "fill-height": "" }
                    },
                    [
                      _c("v-switch", {
                        staticClass: "py-0 my-0",
                        attrs: {
                          color: "primary",
                          "hide-details": "",
                          label: _vm.$t(_vm.lblSetting.equipmentDisabled)
                        },
                        model: {
                          value: _vm.Disabled,
                          callback: function($$v) {
                            _vm.Disabled = $$v
                          },
                          expression: "Disabled"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs2: "" } },
                [
                  _vm.$route.meta["filter_by_attribut"] &&
                  _vm.dtFilterAttributs.length
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            flat: !_vm.showAttributFilter,
                            dark: !_vm.showAttributFilter,
                            icon: "",
                            color: _vm.showAttributFilter
                              ? "secondary"
                              : "greyDark"
                          },
                          on: {
                            click: function($event) {
                              _vm.showAttributFilter = !_vm.showAttributFilter
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("tune")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { top: "" } },
                    [
                      _c(
                        "template",
                        { slot: "activator" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                outline: "",
                                icon: "",
                                color: "secondary"
                              },
                              on: { click: _vm.resetFilters }
                            },
                            [_c("v-icon", [_vm._v("delete_forever")])],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Réinitialiser le filtre de recherche")
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.$route.meta["filter_by_attribut"] && _vm.dtFilterAttributs.length
            ? _c(
                "v-form",
                {
                  model: {
                    value: _vm.validFormAttributFilter,
                    callback: function($$v) {
                      _vm.validFormAttributFilter = $$v
                    },
                    expression: "validFormAttributFilter"
                  }
                },
                [
                  _vm.showAttributFilter
                    ? _c(
                        "v-layout",
                        {
                          attrs: { row: "", wrap: "", "ml-4": "", "mt-2": "" }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "mr-3": "", "mt-2": "" } },
                            [
                              _c("h3", { staticClass: "mb-2" }, [
                                _vm._v("Filtrer par attributs")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "mr-3": "", "mb-2": "" } },
                            [
                              _c(
                                "div",
                                _vm._l(_vm.attributeFilters, function(
                                  att,
                                  index
                                ) {
                                  return _c(
                                    "v-chip",
                                    {
                                      key: index,
                                      attrs: {
                                        color: "primary",
                                        dark: "",
                                        close: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.removeFilter(index)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "pr-1",
                                          staticStyle: { width: "auto" }
                                        },
                                        [_vm._v(_vm._s(att.attribut.name))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "pr-1",
                                          staticStyle: { width: "auto" }
                                        },
                                        [
                                          _c("b", [
                                            _vm._v(_vm._s(att.operator.name))
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      att.attribut.attribute_type.type ===
                                      "boolean"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "pr-1",
                                              staticStyle: { width: "auto" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  att.value1 ? "Oui" : "Non"
                                                )
                                              )
                                            ]
                                          )
                                        : att.attribut.attribute_type.type ===
                                          "date"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "pr-1",
                                              staticStyle: { width: "auto" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(att.value1)
                                                )
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass: "pr-1",
                                              staticStyle: { width: "auto" }
                                            },
                                            [_vm._v(_vm._s(att.value1))]
                                          ),
                                      _vm._v(" "),
                                      att.operator.nbOfValue === 2
                                        ? _c(
                                            "span",
                                            { staticStyle: { width: "auto" } },
                                            [
                                              _c("b", [_vm._v("et")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    att.attribut.attribute_type
                                                      .type === "date"
                                                      ? _vm.formatDate(
                                                          att.value2
                                                        )
                                                      : att.value2
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "", "mr-3": "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.dtFilterAttributs,
                                  "item-text": "name",
                                  "item-value": "id",
                                  label: "Sélectionner l'attribut",
                                  solo: "",
                                  "hide-details": "",
                                  "return-object": "",
                                  chips: "",
                                  rules: [
                                    function(v) {
                                      return !!v || "Attribute is required"
                                    }
                                  ]
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function(data) {
                                      return [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              selected: data.selected,
                                              close: "",
                                              color: "secondary",
                                              "text-color": "whitePure"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.FkAttribut = null
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.truncateString(
                                                    data.item.name,
                                                    10
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.FkAttribut,
                                  callback: function($$v) {
                                    _vm.FkAttribut = $$v
                                  },
                                  expression: "FkAttribut"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "", "mr-3": "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.dtFilterAttributsOperators,
                                  "item-text": "name",
                                  "item-value": "id",
                                  label: "Sélectionner l'opérateur",
                                  solo: "",
                                  disabled: !_vm.FkAttribut,
                                  "hide-details": "",
                                  clearable: "",
                                  "return-object": "",
                                  rules: [
                                    function(v) {
                                      return !!v || "Operator is required"
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.FkAttributOpertor,
                                  callback: function($$v) {
                                    _vm.FkAttributOpertor = $$v
                                  },
                                  expression: "FkAttributOpertor"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.FkAttributOpertor
                            ? _c(
                                "v-flex",
                                { attrs: { xs2: "", "mr-3": "" } },
                                [
                                  _vm.FkAttribut.attribute_type.type ===
                                  "boolean"
                                    ? _c("v-select", {
                                        attrs: {
                                          items: [
                                            { value: true, text: "Oui" },
                                            { value: false, text: "Non" }
                                          ],
                                          label: "Sélectionner une valeur",
                                          rules: [
                                            function(v) {
                                              return (
                                                v !== null ||
                                                "Ce champ est requis"
                                              )
                                            }
                                          ],
                                          solo: ""
                                        },
                                        model: {
                                          value: _vm.attributFilterVal1,
                                          callback: function($$v) {
                                            _vm.attributFilterVal1 = $$v
                                          },
                                          expression: "attributFilterVal1"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.FkAttribut.attribute_type.type === "date"
                                    ? _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            "close-on-content-click": false,
                                            "nudge-right": 40,
                                            lazy: "",
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "full-width": "",
                                            "min-width": "290px"
                                          },
                                          model: {
                                            value: _vm.AttributFilterDateValue1,
                                            callback: function($$v) {
                                              _vm.AttributFilterDateValue1 = $$v
                                            },
                                            expression:
                                              "AttributFilterDateValue1"
                                          }
                                        },
                                        [
                                          _c(
                                            "template",
                                            { slot: "activator" },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Choisir une date",
                                                  "prepend-icon": "event",
                                                  solo: "",
                                                  readonly: "",
                                                  rules: [
                                                    function(v) {
                                                      return (
                                                        !!v ||
                                                        "Ce champ est requis"
                                                      )
                                                    }
                                                  ]
                                                },
                                                model: {
                                                  value:
                                                    _vm.attributFilterDate1Formated,
                                                  callback: function($$v) {
                                                    _vm.attributFilterDate1Formated = $$v
                                                  },
                                                  expression:
                                                    "attributFilterDate1Formated"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-date-picker", {
                                            attrs: { locale: "fr-fr" },
                                            on: {
                                              input: function($event) {
                                                _vm.AttributFilterDateValue1 = false
                                              }
                                            },
                                            model: {
                                              value: _vm.attributFilterVal1,
                                              callback: function($$v) {
                                                _vm.attributFilterVal1 = $$v
                                              },
                                              expression: "attributFilterVal1"
                                            }
                                          })
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  ["string", "number"].includes(
                                    _vm.FkAttribut.attribute_type.type
                                  )
                                    ? _c("v-text-field", {
                                        attrs: {
                                          label: "Valeur 1",
                                          solo: "",
                                          type:
                                            _vm.FkAttribut.attribute_type
                                              .type === "number"
                                              ? "number"
                                              : "text",
                                          rules: [
                                            function(v) {
                                              return (
                                                !!v || "Ce champ est requis"
                                              )
                                            }
                                          ],
                                          suffix: _vm.FkAttribut.unit
                                        },
                                        model: {
                                          value: _vm.attributFilterVal1,
                                          callback: function($$v) {
                                            _vm.attributFilterVal1 = $$v
                                          },
                                          expression: "attributFilterVal1"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.FkAttributOpertor &&
                          _vm.FkAttributOpertor.nbOfValue == 2
                            ? _c(
                                "v-flex",
                                { attrs: { xs2: "", "mr-3": "" } },
                                [
                                  _vm.FkAttribut.attribute_type.type === "date"
                                    ? _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            "close-on-content-click": false,
                                            "nudge-right": 40,
                                            lazy: "",
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "full-width": "",
                                            "min-width": "290px"
                                          },
                                          model: {
                                            value: _vm.AttributFilterDateValue2,
                                            callback: function($$v) {
                                              _vm.AttributFilterDateValue2 = $$v
                                            },
                                            expression:
                                              "AttributFilterDateValue2"
                                          }
                                        },
                                        [
                                          _c(
                                            "template",
                                            { slot: "activator" },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Choisir une date",
                                                  "prepend-icon": "event",
                                                  solo: "",
                                                  readonly: "",
                                                  rules: [
                                                    function(v) {
                                                      return (
                                                        !!v ||
                                                        "Ce champ est requis"
                                                      )
                                                    }
                                                  ]
                                                },
                                                model: {
                                                  value:
                                                    _vm.attributFilterDate2Formated,
                                                  callback: function($$v) {
                                                    _vm.attributFilterDate2Formated = $$v
                                                  },
                                                  expression:
                                                    "attributFilterDate2Formated"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-date-picker", {
                                            attrs: { locale: "fr-fr" },
                                            on: {
                                              input: function($event) {
                                                _vm.AttributFilterDateValue2 = false
                                              }
                                            },
                                            model: {
                                              value: _vm.attributFilterVal2,
                                              callback: function($$v) {
                                                _vm.attributFilterVal2 = $$v
                                              },
                                              expression: "attributFilterVal2"
                                            }
                                          })
                                        ],
                                        2
                                      )
                                    : _c("v-text-field", {
                                        attrs: {
                                          label: "Valeur 2",
                                          solo: "",
                                          type:
                                            _vm.FkAttribut.attribute_type
                                              .type === "number"
                                              ? "number"
                                              : "text",
                                          rules: [
                                            function(v) {
                                              return (
                                                !!v || "Ce champ est requis"
                                              )
                                            }
                                          ],
                                          suffix: _vm.FkAttribut.unit
                                        },
                                        model: {
                                          value: _vm.attributFilterVal2,
                                          callback: function($$v) {
                                            _vm.attributFilterVal2 = $$v
                                          },
                                          expression: "attributFilterVal2"
                                        }
                                      })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { shrink: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    disabled: !_vm.validFormAttributFilter,
                                    icon: "",
                                    color: "primary"
                                  },
                                  on: { click: _vm.AddAttributFilter }
                                },
                                [_c("v-icon", [_vm._v("add")])],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { shrink: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "text-none primary--text font-weight-bold",
                                  attrs: {
                                    disabled: !_vm.attributeFilters.length,
                                    round: "",
                                    color: "turquoise"
                                  },
                                  on: { click: _vm.ApplyAttributeFilters }
                                },
                                [
                                  _c("v-icon", [_vm._v("check")]),
                                  _vm._v("\n            Appliquer\n          ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card",
            {
              staticClass: "ml-4 mr-3 mt-3",
              attrs: { flat: "", color: "transparent" }
            },
            [
              _c(
                "v-data-table",
                {
                  staticClass:
                    "dr-table--transparent dr-table__profile elevation-2",
                  attrs: {
                    headers: _vm.coTableHeaders,
                    items: _vm.coSource,
                    pagination: _vm.pagination,
                    "total-items": _vm.Total,
                    loading: _vm.Loading,
                    "rows-per-page-items": [10, 25, 50],
                    "rows-per-page-text": "Lignes par page",
                    "no-data-text": "Pas de données disponibles"
                  },
                  on: {
                    "update:pagination": function($event) {
                      _vm.pagination = $event
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c(
                            "tr",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  _vm.handleEquipmentClick(props.item)
                                }
                              }
                            },
                            [
                              _c(
                                "td",
                                { staticClass: "primary--text" },
                                [
                                  _c(
                                    "v-avatar",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        color: props.item.picture
                                          ? "#FFF !important"
                                          : "primary"
                                      }
                                    },
                                    [
                                      props.item.picture
                                        ? _c("img", {
                                            attrs: { src: props.item.picture }
                                          })
                                        : props.item.fk_character_problem_lvl2
                                        ? _c("img", {
                                            staticStyle: {
                                              width: "27px",
                                              height: "27px"
                                            },
                                            attrs: {
                                              src: props.item.subcategory.picto
                                            }
                                          })
                                        : props.item.category.picto
                                        ? _c("img", {
                                            staticStyle: {
                                              width: "27px",
                                              height: "27px"
                                            },
                                            attrs: {
                                              src: props.item.category.picto
                                            }
                                          })
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "headline white--text"
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.formatAcronym(
                                                      props.item.name
                                                    )
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.Loading
                                ? _c("td", { staticClass: "primary--text" }, [
                                    props.item.number_equipment > 1
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "primary--text__head"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                props.item.number_equipment +
                                                  "x "
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "primary--text__head" },
                                      [
                                        _c("b", [
                                          _vm._v(_vm._s(props.item.name))
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "grey--text sub-title--text"
                                      },
                                      [_vm._v(_vm._s(props.item.brand))]
                                    ),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "italic--text grey--text"
                                      },
                                      [_vm._v(_vm._s(props.item.reference))]
                                    )
                                  ])
                                : _c(
                                    "td",
                                    { staticClass: "primary--text" },
                                    [
                                      _c("profile-table-loader", {
                                        attrs: { "loader-type": "multi-column" }
                                      })
                                    ],
                                    1
                                  ),
                              _vm._v(" "),
                              !_vm.Loading
                                ? [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "primary--text",
                                        class: {
                                          "empty--column": !props.item
                                            .description
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(props.item.description || "-")
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "primary--text",
                                        class: {
                                          "empty--column": !props.item.category
                                            .name
                                        }
                                      },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(props.item.category.name)
                                          )
                                        ]),
                                        _c("br"),
                                        _vm._v(" "),
                                        props.item.fk_character_problem_lvl2
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  "" +
                                                    props.item.subcategory.name
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "primary--text",
                                        class: {
                                          "empty--column": !props.item.apartment
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            props.item.apartment
                                              ? props.item.apartment
                                                  .apartment_number
                                              : "-"
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "primary--text" }, [
                                      _vm._v(_vm._s(props.item.location))
                                    ]),
                                    _vm._v(" "),
                                    props.item.contractors_assigned.length === 0
                                      ? _c(
                                          "td",
                                          {
                                            staticClass:
                                              "primary--text empty--column"
                                          },
                                          [_vm._v("-")]
                                        )
                                      : _c(
                                          "td",
                                          { staticClass: "primary--text" },
                                          _vm._l(
                                            props.item.contractors_assigned,
                                            function(contractor) {
                                              return _c("div", [
                                                _vm._v(
                                                  _vm._s(contractor.fullname)
                                                )
                                              ])
                                            }
                                          )
                                        )
                                  ]
                                : [
                                    _c(
                                      "td",
                                      { staticClass: "primary--text" },
                                      [
                                        _c("profile-table-loader", {
                                          attrs: { "loader-type": "column" }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "primary--text" },
                                      [
                                        _c("profile-table-loader", {
                                          attrs: { "loader-type": "column" }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "primary--text" },
                                      [
                                        _c("profile-table-loader", {
                                          attrs: { "loader-type": "column" }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "primary--text" },
                                      [
                                        _c("profile-table-loader", {
                                          attrs: { "loader-type": "column" }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "primary--text" },
                                      [
                                        _c("profile-table-loader", {
                                          attrs: { "loader-type": "column" }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "primary--text" },
                                      [
                                        _c("profile-table-loader", {
                                          attrs: { "loader-type": "column" }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                            ],
                            2
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t(_vm.lblSetting.profileTableNoData)) +
                        "\n        "
                    )
                  ]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b4285ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b4285ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/components/block-equipment-list/template.html
// module id = null
// module chunks = 